'use client'

import { Suspense } from 'react'

import dynamic from 'next/dynamic'

import type { LicenseMapInteractiveProps } from './license-map-interactive'

const LicenseMap = dynamic(() => import('./license-map-interactive').then((module) => module.LicenseMapInteractive))

// Same loader shape as CoverageMapLazy: the server-rendered map/table (children)
// show immediately, and the interactive island (tooltip + legend filter) lands
// in its own chunk once the widget is actually on the page.
export const LicenseMapLazy = ({ children, ...props }: LicenseMapInteractiveProps) => (
  <Suspense fallback={<div className="ht-license-map not-prose relative">{children}</div>}>
    <LicenseMap {...props}>{children}</LicenseMap>
  </Suspense>
)
